import React from 'react';

const JS_2009_ES5 = () => {
  return (
    <div >
      <h1>JS_2009_ES5</h1>
      <p>Placeholder component for: "JS 2009 (ES5)"</p>
    </div>
  );
};

export default JS_2009_ES5;
